function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { usePostPageEditor } from "../PostPageEditorContext";
import { useTodoSingularAction } from "../PostPageTodo";
import usePostPageTodos from "./usePostPageTodos";
import PostPageTodosMain from "./PostPageTodosMain";
const PostPageTodos = (props)=>{
    const { todos , todoLists , disabled , workspaceMembers , labels , rootTopicId  } = props;
    const { state  } = usePostPageEditor();
    usePostPageTodos({
        disabled
    });
    // Similar logic used in `PostPageTodosOrphanTodos`
    const openTodoNewEditor = state.editor === "CREATE_TODO" && state.editorPosition === Number.MAX_SAFE_INTEGER;
    // Similar logic used in `PostPageTodoListNewEditor`
    const openTodoListNewEditor = state.editor === "CREATE_TODOLIST";
    const render = todos.length > 0 || todoLists.length > 0 || openTodoListNewEditor || openTodoNewEditor;
    const flattenTodos = useMemo(()=>{
        return [
            ...todos,
            ...todoLists.flatMap((todoList)=>todoList.todos.nodes)
        ];
    }, [
        todoLists,
        todos
    ]);
    const { elements , todoSingularAction , todoSupportedActions  } = useTodoSingularAction({
        todos: flattenTodos,
        workspaceMembers,
        labels,
        rootTopicId
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            elements,
            render && /*#__PURE__*/ _jsx(PostPageTodosMain, _objectSpread({
                todoSupportedActions: todoSupportedActions,
                todoSingularAction: todoSingularAction
            }, props))
        ]
    });
};
export default PostPageTodos;
